<tt-page>
    <tt-card>
        <table class="risk-matrix">
            <tbody>
                <tr *ngFor="let row of rows">
                    <th scope="row" [style.font-size]="smallFont">{{ consequenceName(row.consequence) }}</th>
                    <td *ngFor="let cell of row.cells" [style.background]="cell.background" [style.color]="cell.color">
                        <button type="button" [attr.aria-label]="cell.probability + ' / ' + cell.consequence" [disabled]="loading" (click)="filterCell(cell)">
                            <span *ngIf="cell.showCount" class="badge">{{ cell.count }}</span>&nbsp;
                        </button>
                    </td>
                </tr>
                <tr>
                    <td><button type="button" aria-label="Toggle risk descriptions" [attr.aria-expanded]="showDescriptions" (click)="showDescriptions = !showDescriptions"><span [class]="showDescriptions ? 'far fa-eye-slash' : 'far fa-eye'"></span></button></td>
                    <th *ngFor="let probability of probabilities" scope="col" [style.font-size]="smallFont">{{ probability.probability_name }}</th>
                </tr>
            </tbody>
        </table>
        <tt-button *ngIf="cellClicked > 0" ttText="risk_elements_show_all" [ttLoading]="loading" (ttClick)="showAll()" ttTextAlign="left"></tt-button>
        <table [hidden]="!showDescriptions" class="risk-descriptions">
            <tbody><tr *ngFor="let level of levels">
                <th [style.background]="level.background" [style.color]="level.color" [style.font-size]="user.fontSize">{{ level.risklevel }}</th>
                <td [style.font-size]="smallFont">{{ level.risklevel_action }}</td>
            </tr></tbody>
        </table>
    </tt-card>
    <tt-list [ttData]="items" [ttGoto]="false" [ttButtons]="rowButtons" (ttClick)="open($event)"></tt-list>
    <tt-card>
        <tt-button-goto ttText="checklist_new" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight ttGoto="riskelement-test" [ttGotoParms]="{ riskelement_keyno: '0', argtype: 'custact_no', argvalue: params.argvalue }"></tt-button-goto>
        <tt-button-goto ttText="riskelements_print" ttIcon="fas fa-print" ttTextAlign="center" ttGoto="selectreport" [ttGotoParms]="{ webpage_name: 'riskelements', argtype: 'custact_no', argvalue: params.argvalue }"></tt-button-goto>
    </tt-card>
</tt-page>
<p *ngIf="error" role="alert">{{ error }}</p>
